export default {
    DetailsOfThirdPartySalesOrder: {
        typeE: '异常类型',
        reasonE: '异常详情',
        Suggestions: '操作建议',
        Order: '订单详情',
        log: '操作日志',
        Circulation: '流转状态',
        need: '无需流转',
        progress: '订单进度',
        Normal: '正常流转',
        party: '三方订单已成功转单内部销售订单进行发货流转',
        Suspend: '暂停流转',
        Reason: '原因',
        information: '订单信息',
        Trantypesaction: '订单类型',
        number: '客户订单号',
        Internal: '内部订单号',
        Platform: '平台状态',
        Refund: '退款状态',
        Sales: '销售店铺',
        employee: '销售人员',
        placement: '下单时间',
        pulling: '拉单时间',
        dodgeCompany: '物流公司',
        dodgeAccount: '物流账户',
        amount: '订单金额',
        Total: '商品总金额',
        Yuan: '元',
        Goods: '优惠金额',
        Discount: '商家承担优惠金额',
        Preferential: '三方承担优惠金额',
        receivable: '应收总金额',
        Freight: '运费',
        Customer: '客服调整金额',
        Remarks: '备注',
        comments: '买家备注',
        Merchant: '商家备注',
        Receiving: '收货信息',
        Method: '提货方式',
        store: '提货店铺',
        nickname: '买家昵称',
        Consignee: '收货人',
        Mobile: '手机',
        Address: '地址',
        Paymentinformation: '支付信息',
        Paymentmethod: '支付方式',
        Paymentstatus: '支付状态',
        Paymenttime: '支付时间',
        actual: '买家实付金额',
        Invoice: '发票信息',
        No: '暂无开票申请',
        Commodity: '商品清单',
        Serial: '序号',
        Sub: '子订单编号',
        Notice: '平台状态',
        Issue: '处理状态',
        status: '退款状态',
        image: '商品图片',
        Number: '平台商品名称',
        item: '平台货品ID',
        specification: '平台规格ID',
        Platformitem: '平台货品编码',
        Platformcode: '平台规格编码',
        Platformname: '平台规格名称',
        Internalcode: '内部SKU编码',
        Whether: '是否赠品',
        Quantity: '数量',
        Unit: '平台货品单价',
        price: '平台货品总价',
        amountgoods: '商品总优惠金额',
        Adjustment: '调整金额',
        Allocate: '分摊三方优惠',
        discounts: '分摊商家优惠',
        Allocated: '分摊运费',
        paid: '已付金额',
        Note: '退款单编号',
        Refundamount: '退款金额',
        Refundquantity: '退款数量',
        Totalproducts: '商品总数：',
        Totalnumber: 'SKU总数：',
        temporarily: '暂无',
    }
};
